import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

export function PageHeader({
  title,
  description,
  actions,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, type: 'spring' as const, stiffness: 200, damping: 20 }}
      className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8"
    >
      {/*
        Type-scale convention for the whole app:
        page title = text-xl md:text-2xl font-display font-medium
        card/section title (CardHeader) = text-lg font-display font-medium
        body copy = text-sm · secondary/meta = text-xs
      */}
      <div className="flex flex-col gap-1 max-w-2xl">
        <h1 className="text-xl md:text-2xl font-display font-medium text-zinc-900 dark:text-white tracking-tight">
          {title}
        </h1>
        {description !== undefined && (
          <div className="text-zinc-500 dark:text-zinc-400 text-sm">{description}</div>
        )}
      </div>
      {actions !== undefined && <div className="flex items-center gap-3 shrink-0">{actions}</div>}
    </motion.div>
  );
}
